import api from '@/api'
const state = {
    apiProtocol: 'https://',
    // apiHost: '192.168.1.13',
    apiHost: 'api.i868.ru',
    apiPath: '/',
    apiVersionPrefix: 'v',
    apiVersion: '1'
}

const mutations = {
}

const getters = {
	apiGetUrl (state, getters) {
		return state.apiProtocol + state.apiHost + state.apiPath + state.apiVersionPrefix + state.apiVersion
	}
}

const actions = {
    async apiSendFeedback ({ commit, state }, data) {
        let out = {
            success: false
        }
        let r = await api.feedback.sendFeedback({contact: data.contact})
        out.success = r.isSuccess
        out.message = r.error.message
        return out
    }
}
export default {
	state,
	getters,
	mutations,
	actions
}


// WEBPACK FOOTER //
// ./src/store/modules/api/api.js